import { defineStore } from 'pinia';

// 将所有属性设置为非必选
type MakeAllPropOptional<T> = {
  [P in keyof T]?: T[P] extends Record<string, any> ? MakeAllPropOptional<T[P]> : T[P];
};

export type NavbarInfo = {
  height: number;
};
export type TabbarInfo = {
  height: number;
};
export type AppInfo = {
  navbarInfo: NavbarInfo;
  tabbarInfo: TabbarInfo;
};

const defaultAppInfo = (): AppInfo => ({
  navbarInfo: { height: 0 },
  tabbarInfo: { height: 0 },
});

export const useAppInfo = defineStore('useAppInfo', () => {
  const appInfo = ref<AppInfo>(defaultAppInfo());

  const getAppInfo = () => appInfo.value;
  const getNavbarInfo = () => appInfo.value.navbarInfo;
  const setNavbarInfo = (opt: Partial<NavbarInfo>) => Object.assign(getNavbarInfo(), opt);
  const getTabbarInfo = () => appInfo.value.tabbarInfo;
  const setTabbarInfo = (opt: Partial<NavbarInfo>) => Object.assign(getTabbarInfo(), opt);

  return {
    appInfo,

    getAppInfo,
    getNavbarInfo,
    setNavbarInfo,
    getTabbarInfo,
    setTabbarInfo,
  };
});
